import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Formik, Form } from 'formik'
import axiosService from '../../../../../../utils/AxiosService'
import { useParams } from 'react-router-dom'
import { DraftContext } from '../../../../../../contexts/DraftContext'
import { toastError, toastSuccess } from '../../../../../FormComponents/Toasts'
import { useReadOnly } from '../../../../../../contexts/ReadOnlyContext'

export default observer(function CaptionUdateForm({action}){
  const readOnly = useReadOnly()
  const { id, action_id } = useParams()
  const { draftState, actions } = useContext(DraftContext)

  const handleDescriptionUpdate = (action_data) => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/actions/${action_id}`, {action_data})
      .then((updatedAction) => {
        toastSuccess('The caption has been saved!')
        action.caption = updatedAction.caption
        draftState.actions = actions.map(action => action.id === updatedAction.id ? new Action(updatedAction) : action)
      })
      .catch(error => toastError(error))
  }

  return (
    <Formik
      initialValues={{caption: action.caption || ''}}
      enableReinitialize
      onSubmit={handleDescriptionUpdate}
    >
      {({ handleBlur, handleChange, values, touched, errors }) => (
        <Form className='flex flex-col justify-center my-5'>
          <div className="flex flex-col border-1 border-primary dark:border-rb-dark-mode-lighter rounded-lg bg-white dark:bg-rb-dark-mode p-2">
            <p className="font-bold p-2 pb-0 dark:text-white">Caption</p>
            <textarea
              name='caption'
              rows="3"
              className='border-none rounded-lg w-full focus:ring-transparent dark:bg-rb-dark-mode dark:text-white dark:placeholder-gray-400'
              placeholder='Add post caption...'
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.caption}
              readOnly={readOnly}
              style={{ resize: 'none' }}
            />
            {!readOnly && (
              <div className='flex items-center justify-end mt-1'>
                <button
                  type="submit"
                  className="submit text-white bg-rb-green rounded-md py-1 px-3 text-center active:shadow-outer active:shadow-rb-green"
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  )
})
